import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { Card, CardContent, Typography } from '@material-ui/core';
import styled from 'styled-components';

const ChartCard = styled(Card)`
  height: 320px;
`;

const ChartContent = styled(CardContent)`
  height: 100%;
`;

const TimeSeriesChart = ({ title, data, xKey, series }) => {
  return (
    <ChartCard elevation={2}>
      <ChartContent>
        <Typography variant="subtitle1" gutterBottom>
          {title}
        </Typography>

        <ResponsiveContainer width="100%" height={260}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />

            <XAxis dataKey={xKey} tick={{ fontSize: 11 }} minTickGap={20} />
            <YAxis tick={{ fontSize: 11 }} />
            <Tooltip />
            <Legend />

            {series.map((s) => (
              <Line
                key={s.key}
                type="monotone"
                dataKey={s.key}
                name={s.label}
                stroke={s.stroke}
                dot={false}
                strokeWidth={2}
                isAnimationActive={false}
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </ChartContent>
    </ChartCard>
  );
};

export default TimeSeriesChart;
